import { CommonModule } from '@angular/common';
import { NgModule, ModuleWithProviders } from '@angular/core';

import { LibComponent } from './component/lib.component';
import { LibService } from './service/lib.service';

// Export module's public API
export { LibComponent } from './component/lib.component';
export { LibService } from './service/lib.service';
export class PdfViewerModule {
/**
 * @return {?}
 */
static forRoot(): ModuleWithProviders {
    return {
      ngModule: PdfViewerModule,
      providers: [LibService]
    };
  }
static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  imports: [
    CommonModule
  ],
  exports: [LibComponent],
  declarations: [LibComponent]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function PdfViewerModule_tsickle_Closure_declarations() {
/** @type {?} */
PdfViewerModule.decorators;
/**
 * @nocollapse
 * @type {?}
 */
PdfViewerModule.ctorParameters;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
